module.exports = __webpack_public_path__ + "static/media/184142r.16a8dae5.pdf";